import { countryCodes } from '../../constants/countries'
import { GeneralSettings, HeatpumpIo, StorageIo } from '../forms'

/**
 * Only 1 SG-Ready device can be connected to an EMC, but Htc320h I/O
 * in German installations can be connected to a different socket on the EMC.
 * In that case it is not considered an SG-Ready device.
 *
 * The outputs and nominal power are hidden. The message "Not Used" is shown in the outputs.
 * Also, in HTC320H I/O's PUT request, Nominal power must be sent as 0.
 *
 * @returns if HTC320H I/O should NOT be treated as an SG-Ready device.
 */
export const getTreatHtcAsNonSgReady = (generalSettings: GeneralSettings, storage: StorageIo | null, heatpump: HeatpumpIo | null): boolean => {
  const isGerman = generalSettings.location.country === countryCodes.germany
  const hasStorageIo = !!storage
  const hasHeatpumpIo = !!heatpump

  return isGerman && (hasStorageIo || hasHeatpumpIo)
}
